import React from 'react';
import './Contact.css';
import { FaGithub, FaLinkedin, FaTwitter, FaInstagram } from "react-icons/fa";
import { IoMdMailOpen } from 'react-icons/io';

const Contact = () => {
    return (
        <div className="c" id="Contacts">
            <div className="c-wrapper">
                    <h1 className="c-title">Let's get connected</h1>

                    <div className="c-email">
                        <text className="num_email">+91-9893420288 | <a href={"mailto: sachinkarun02@gmail.com"} className="num_email">sachinkarun02@gmail.com</a></text>
                    </div>

                    <div className="c-icons">
                        <section className="line"></section>
                        <div className="icon-list">
                            <a href="https://www.instagram.com/sachin_karun" target="_blank" rel="noreferrer">
                                <FaInstagram className="icon"/>
                            </a>
                            <a href="https://github.com/sachinkarun" target="_blank" rel="noreferrer">
                                <FaGithub className="icon"/>
                            </a>
                            <a href={"mailto: sachinkarun02@gmail.com"} target="_blank" rel="noreferrer">
                                <IoMdMailOpen className="icon"/>
                            </a>
                            <a href="https://www.linkedin.com/in/sachin-karun" target="_blank" rel="noreferrer">
                                <FaLinkedin className="icon"/>
                            </a>
                            <a href="https://twitter.com/SachinKarun" target="_blank" rel="noreferrer">
                                <FaTwitter className="icon"/>
                            </a>
                        </div>
                        {/* <div className="line"></div> */}
                    </div>
            </div>
        </div>
    )
}

export default Contact
